import React from 'react';
import './styles.css';

// Fixed positions spread evenly across full page width
const petals = [
  { id: 0,  left: '2%',  width: 8,  height: 12, delay: '0s',    duration: '14s', rotate: 0,   opacity: 0.16 },
  { id: 1,  left: '9%',  width: 11, height: 18, delay: '3.5s',  duration: '17s', rotate: 86,  opacity: 0.13 },
  { id: 2,  left: '16%', width: 9,  height: 15, delay: '7s',    duration: '12s', rotate: 172, opacity: 0.20 },
  { id: 3,  left: '24%', width: 13, height: 21, delay: '1.5s',  duration: '16s', rotate: 43,  opacity: 0.14 },
  { id: 4,  left: '31%', width: 8,  height: 12, delay: '9s',    duration: '19s', rotate: 215, opacity: 0.18 },
  { id: 5,  left: '39%', width: 10, height: 18, delay: '5s',    duration: '13s', rotate: 129, opacity: 0.12 },
  { id: 6,  left: '47%', width: 12, height: 15, delay: '11.5s', duration: '15s', rotate: 301, opacity: 0.16 },
  { id: 7,  left: '55%', width: 9,  height: 21, delay: '2s',    duration: '18s', rotate: 57,  opacity: 0.14 },
  { id: 8,  left: '62%', width: 11, height: 12, delay: '8s',    duration: '14s', rotate: 244, opacity: 0.19 },
  { id: 9,  left: '70%', width: 8,  height: 18, delay: '0.5s',  duration: '21s', rotate: 158, opacity: 0.13 },
  { id: 10, left: '77%', width: 13, height: 15, delay: '6s',    duration: '16s', rotate: 330, opacity: 0.17 },
  { id: 11, left: '84%', width: 9,  height: 21, delay: '12s',   duration: '12s', rotate: 72,  opacity: 0.15 },
  { id: 12, left: '91%', width: 10, height: 12, delay: '4s',    duration: '20s', rotate: 187, opacity: 0.12 },
  { id: 13, left: '97%', width: 8,  height: 18, delay: '9.5s',  duration: '15s', rotate: 265, opacity: 0.18 },
];

const PetalRain = () => (
  <div className="petal-rain" aria-hidden="true">
    {petals.map(p => (
      <div
        key={p.id}
        className="petal"
        style={{
          left: p.left,
          width: p.width,
          height: p.height,
          animationDelay: p.delay,
          animationDuration: p.duration,
          '--rotate': `${p.rotate}deg`,
          opacity: p.opacity,
        }}
      />
    ))}
  </div>
);

export default PetalRain;
